import { Text } from "@daangn/carotene";
import { IconSlider2HorizontalLine } from "@daangn/react-monochrome-icon";

import * as css from "./FilterModalTriggerButton.css";

type Props = {
  label: string;
  onClick?: () => void;
};

const FilterModalTriggerButton = ({ label, onClick }: Props) => {
  return (
    <button onClick={onClick} className={css.trigger}>
      <IconSlider2HorizontalLine size={18} />
      <Text size="small" color="neutral">
        {label}
      </Text>
    </button>
  );
};

export default FilterModalTriggerButton;
